import { Link } from "react-router-dom";
import { NAV, ZONES } from "@/data/content";
import { useGoTo } from "@/lib/useGoTo";

const linkCls = "block py-1.5 text-slate-200 hover:text-[#FFEF00] transition-colors text-left";

export const Footer = () => {
  const go = useGoTo();
  return (
    <footer data-testid="site-footer" className="relative pt-24 pb-28 lg:pb-10 border-t border-white/10 overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <div className="grid sm:grid-cols-2 md:grid-cols-12 gap-10">
          <div className="sm:col-span-2 md:col-span-4">
            <img src="/brand/logo.png" alt="ZoopUp" className="h-16 md:h-20 w-auto" />
            <p className="mt-6 text-slate-300 max-w-sm">15 zones of bowling, arcade, VR, go-karts, trampolines, sports simulators, dining & parties, all at ZoopUp.</p>
          </div>
          <div className="md:col-span-2">
            <p className="font-mono text-xs uppercase tracking-[0.25em] text-slate-400 mb-4">Explore</p>
            {NAV.map((n) => n.to
              ? <Link key={n.label} to={n.to} data-testid={`footer-nav-${n.label.toLowerCase()}`} className={linkCls}>{n.label}</Link>
              : <button key={n.label} data-testid={`footer-nav-${n.label.toLowerCase()}`} onClick={() => go(n.id)} className={linkCls}>{n.label}</button>)}
          </div>
          <div className="md:col-span-3">
            <p className="font-mono text-xs uppercase tracking-[0.25em] text-slate-400 mb-4">Zones</p>
            <div className="grid grid-cols-2 gap-x-4">
              {ZONES.map((z) => <Link key={z.key} to={`/zones/${z.key}`} data-testid={`footer-zone-${z.key}`} className={`${linkCls} text-sm`}>{z.title}</Link>)}
            </div>
          </div>
          <div className="md:col-span-3">
            <p className="font-mono text-xs uppercase tracking-[0.25em] text-slate-400 mb-4">Contact</p>
            <p className="text-slate-200 py-1.5">www.zoopup.in</p>
            <a href="mailto:ceo@zoopup.in" data-testid="footer-email" className="block text-slate-200 py-1.5 hover:text-[#FFEF00]">ceo@zoopup.in</a>
            <a href="tel:+919152661100" data-testid="footer-phone-india" className="block text-slate-200 py-1.5 hover:text-[#FFEF00]">+91 9152-66-1100</a>
            <p className="text-slate-300 py-1.5 text-sm leading-relaxed" data-testid="footer-address-jalandhar">ZoopUp Jalandhar, 3rd floor, Above Zudio Showroom, Namdev Chowk, Jalandhar, Punjab-144001</p>
            <p className="text-slate-300 py-1.5 text-sm leading-relaxed" data-testid="footer-address-delhi">ZoopUp Delhi, HC Sen Marg, Chandni Chowk, Delhi-110006</p>
            <a href="tel:+8613073214908" data-testid="footer-phone" className="block text-slate-200 py-1.5 hover:text-[#FFEF00]">+86-13073214908</a>
            <p className="text-slate-300 py-1.5 text-sm leading-relaxed" data-testid="footer-address">ZoopUp China, No.15-3, 3rd floor, Kengtou Village West Line, Nancun Town, Panyu District, Guangzhou, Guangdong, China-511440</p>
            <p className="text-slate-200 py-1.5">[Instagram / Facebook links]</p>
          </div>
        </div>
        <p aria-hidden className="mt-16 font-display font-black text-[17vw] leading-[0.8] text-transparent select-none" style={{ WebkitTextStroke: "1px rgba(255,239,0,0.25)" }}>ZOOPUP</p>
        <div className="mt-8 flex flex-col sm:flex-row justify-between gap-3 text-xs text-slate-400">
          <p>© {new Date().getFullYear()} ZoopUp. All rights reserved.</p>
          <Link to="/admin" data-testid="footer-admin-link" className="hover:text-white">Staff login</Link>
        </div>
      </div>
    </footer>
  );
};
